/* eslint-disable no-unused-expressions */

import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import sysJwt from "../../../utils/sysJwt";
import SysForm from "../../commonComponents/sysForm";
import { post } from "../../../utils/sysAxios";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import SysTable from "../../commonComponents/SysTable";

class ElectricityBorrowingConfig extends Component {
  state = {
    data: {
      isActive: false,
      maxBorrowingAmount: "",
    },

    editUrl: "/api/data/EditElectricityBorrowingConfig",
    dataUrl: "/api/data/GetElectricityBorrowingConfigs",

    inModalMode: false,
    modalWidth: "40vw",

    editEntityId: 0,

    tableData: [],
  };

  componentDidMount() {
    this.getData();
  }

  updateForm = (inputId, inputValue) => {
    var data = this.state.data;
    data[inputId] = inputValue;
    this.setState({ data });
  };

  showForm() {
    this.setState({ inModalMode: true });
  }

  closeModal() {
    var data = this.state.data;
    Object.keys(data).forEach(function (key) {
      Array.isArray(data[key]) ? (data[key] = []) : (data[key] = "");
    });
    this.setState({ inModalMode: false, data, editEntityId: 0 });
    this.getData();
  }

  getData() {
    post(this.state.dataUrl, null, this.props.updateIsLoading).then(
      (apiResponse) => {
        this.setState({ tableData: apiResponse.data.respData.data });
      }
    );
  }

  getEditFormData(row) {
    var data = this.state.data;
    data["isActive"] = row.IS_ACTIVE || false;
    data["maxBorrowingAmount"] = row.MAX_BORROWING_AMOUNT ?? "";
    this.setState({ data, editEntityId: row.ID });
  }

  doSubmit() {
    post(
      this.state.editUrl,
      {
        id: this.state.editEntityId,
        isActive: this.state.data.isActive,
        maxBorrowingAmount: this.state.data.maxBorrowingAmount,
      },
      this.props.updateIsLoading
    ).then((apiResponse) => {
      if (apiResponse.data.respCode === 0) {
        this.props.updateIsLoading(false);
        this.closeModal();
      }
    });
  }

  getColumns() {
    const { t } = this.props;
    return [
      {
        id: 1,
        label: t("col.id"),
        field: "ID",
        width: "80px",
      },
      {
        id: 2,
        label: t("col.compound"),
        field: "COMPOUND_NAME",
      },
      {
        id: 3,
        label: t("col.active"),
        field: "IS_ACTIVE",
        cellRenderer: ({ data }) => (
          <span>{data.IS_ACTIVE ? t("ebc.active") : t("ebc.inactive")}</span>
        ),
      },
      {
        id: 4,
        label: t("ebc.maxBorrowingAmount"),
        field: "MAX_BORROWING_AMOUNT",
      },
      {
        id: 5,
        label: t("col.lastUpdate"),
        field: "LAST_UPDATE",
      },
      {
        id: 6,
        label: t("col.actions"),
        field: "SYS_ACTIONS",
        width: "80px",
        resizable: false,
        pinned: true,
        cellRenderer: ({ data }) => (
          <div id="outer">
            {sysJwt.isAuthorized(["CB90"]) && (
              <div className="inner" title="Edit">
                <button
                  className="dropdown-item btn-popup-menu"
                  disabled={this.props.isLoading}
                  onClick={() => {
                    this.getEditFormData(data);
                    this.showForm();
                  }}
                >
                  <i className="fa fa-edit" />
                </button>
              </div>
            )}
          </div>
        ),
      },
    ];
  }

  render() {
    const { t } = this.props;
    return (
      <div className="bms-content-component fade-in">
        <div className="row">
          <div className="col">
            <h4>{t("pages.electricityBorrowingConfig")}</h4>
          </div>
        </div>
        <hr />
        <Dialog
          visible={this.state.inModalMode}
          style={{ width: this.state.modalWidth }}
          onHide={() => this.closeModal()}
          dismissableMask={true}
          closable={false}
          header={
            <h5 className="modal-header">{t("dialog.editTitle")}</h5>
          }
          footer={
            <div>
              <Button
                label={t("btn.save")}
                icon="fa fa-check"
                className="p-button-rounded p-button-secondary"
                disabled={this.props.isLoading}
                onClick={() => this.doSubmit()}
              />
              <Button
                label={t("btn.cancel")}
                icon="fa fa-close"
                className="p-button-rounded p-button-danger"
                onClick={() => this.closeModal()}
              />
            </div>
          }
        >
          <SysForm
            isLoading={this.props.isLoading}
            inEditMode={true}
            data={this.state.data}
            updateForm={this.updateForm}
            inputs={[
              {
                type: "text",
                id: "maxBorrowingAmount",
                label: t("ebc.maxBorrowingAmount"),
                disabled: false,
              },
              {
                type: "checkbox",
                id: "isActive",
                label: t("col.active"),
                disabled: false,
              },
            ]}
          />
        </Dialog>
        <SysTable
          columns={this.getColumns()}
          rows={this.state.tableData}
          pageSizes={[10, 15, 20, 25, 30]}
        />
      </div>
    );
  }
}

export default withTranslation()(ElectricityBorrowingConfig);
